import React from 'react';
import { Chip, Grid, Typography } from '@material-ui/core';
import { Entity } from '@backstage/catalog-model';
import { CardTitle, CardTitleOptions } from '../CardTitle';
import { Avatar, InfoCard } from '@backstage/core-components';
import { GridActions } from '../GidActions';
import {
  EntityTagFilter,
  useEntityList,
} from '@backstage/plugin-catalog-react';
import { CatalogGridAction } from '../GidActions/GridActions';
import { CatalogGridItem } from '../types';
import { extractTagName, subheaderForEntity } from './helpers';
import { ComponentsGrid } from '../ComponentsGrid';
import { useCatalogCardIconStyles } from './styles';
import { ComponentsWithCountersForMultipleEntities } from '../useGetEntities';
export function UserCardItem<T extends CatalogGridItem>({
  row,
  options,
  actions,
  queryParamTags,
  defaultActions,
  componentsWithCounters,
}: {
  row: { entity: Entity; resolved: { name: string } };
  options?: CardTitleOptions;
  actions?: CatalogGridAction<T>[];
  queryParamTags: string[];
  defaultActions?: any;
  componentsWithCounters?: ComponentsWithCountersForMultipleEntities;
}) {
  const classes = useCatalogCardIconStyles();
  const { updateFilters, filters, queryParameters } = useEntityList();

  return (
    <InfoCard
      title={
        <>
          <Avatar
            classes={{ avatar: classes.avatar }}
            displayName={
              (row.entity.spec!.profile! as { displayName?: string })
                .displayName! ?? ''
            }
          />
          <CardTitle
            entity={row.entity}
            options={options}
            style={{ paddingTop: '15px' }}
            title={
              (row.entity.spec!.profile! as { displayName?: string })
                .displayName
            }
          />
        </>
      }
      subheader={subheaderForEntity(
        row.entity,
        updateFilters,
        filters,
        classes,
      )}
      actions={<GridActions actions={actions || defaultActions} row={row} />}
      className={classes.card}
      cardClassName={classes.cardContent}
    >
      <>
        {row.entity.metadata.namespace && (
          <Typography className={classes.namespace}>
            <span className={classes.namespaceLeft}>Namespace:</span>
            <Chip
              className={classes.businessUnitChip}
              key={row.entity.metadata.namespace}
              size="small"
              label={row.entity.metadata.namespace}
            />
          </Typography>
        )}
        {row.entity.metadata.annotations!['ghfb.user/businessUnit'] && (
          <Typography className={classes.namespace}>
            <span className={classes.namespaceLeft}>Business unit:</span>
            <Chip
              className={classes.businessUnitChip}
              key={row.entity.metadata.annotations!['ghfb.user/businessUnit']}
              size="small"
              label={row.entity.metadata.annotations!['ghfb.user/businessUnit']}
            />
          </Typography>
        )}
        {row.entity.metadata.annotations!['ghfb.user/role'] && (
          <Typography className={classes.namespace}>
            <span className={classes.namespaceLeft}>Role:</span>
            <Chip
              className={classes.businessUnitChip}
              key={row.entity.metadata.annotations!['ghfb.user/role']}
              size="small"
              label={row.entity.metadata.annotations!['ghfb.user/role']}
            />
          </Typography>
        )}
        {row.entity.metadata.annotations!['ghfb.user/reportsTo'] && (
          <Typography className={classes.namespace}>
            <span className={classes.namespaceLeft}>Reports to:</span>
            <Chip
              className={classes.businessUnitChip}
              key={row.entity.metadata.annotations!['ghfb.user/reportsTo']}
              size="small"
              label={row.entity.metadata.annotations!['ghfb.user/reportsTo']}
            />
          </Typography>
        )}
        <ComponentsGrid
          className={classes.grid}
          entity={row.entity}
          relationAggregation="direct"
          componentsWithCountersData={componentsWithCounters}
        />
      </>
      {row.entity?.metadata?.tags && (
        <Grid>
          {(row.entity?.metadata?.tags || []).map(t => {
            const tag = extractTagName(t);
            return (
              <Chip
                key={tag.key}
                size="small"
                label={tag.label}
                onClick={() => {
                  queryParameters.tags = [...new Set([...queryParamTags, t])];
                  updateFilters({
                    tags: new EntityTagFilter([
                      ...new Set(filters.tags?.values?.concat([t]) || [t]),
                    ]),
                  });
                }}
              />
            );
          })}
        </Grid>
      )}
    </InfoCard>
  );
}
